import { bool, func, oneOfType, shape, string } from 'prop-types';
import _ from 'lodash';

import messageDescriptor from '../../lingui/LinguiPropTypes';

export const filterPropTypes = {
    id: string,
    title: oneOfType([string, messageDescriptor]),
    required: bool,
    autoApply: bool,
    autoRefresh: bool,
    filterActions: shape({
        setState: func,
        setValid: func,
    }),
};

export const filterPropDefaults = {
    required: false,
    autoApply: false,
    autoRefresh: false,
    filterActions: {
        setState: _.noop,
        setValid: _.noop,
    },
};
